import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import '../css/Formulario_Pacientes.css';

const preguntas = [
  { id: 'p1', texto: '1. Desistimiento voluntario de las pacientes a permanecer durante el periodo establecido del estudio una vez que han firmado carta de consentimiento informado' },
  { id: 'p2', texto: '2. Por criterio médico' },
];

const CriteriosEliminacion = () => {
  const { idPaciente } = useParams();
  const navigate = useNavigate();

  const [respuestas, setRespuestas] = useState({});
  const [comentarios, setComentarios] = useState({});
  const [criteriosExistentes, setCriteriosExistentes] = useState(null);
  const [editId, setEditId] = useState(null);
  const [bloqueado, setBloqueado] = useState(false);

  const BLOQUEO_KEY = `exclusion_bloqueado_${idPaciente}`;

  useEffect(() => {
    const bloqueoGuardado = localStorage.getItem(BLOQUEO_KEY);
    if (bloqueoGuardado === 'true') {
      setBloqueado(true);
    }

    if (idPaciente) {
      fetchCriteriosExclusion();
    }
  }, [idPaciente]);

  const fetchCriteriosExclusion = async () => {
    try {
      const res = await fetch(`https://api.weareinfinite.mx/form/criterios_eliminacion/paciente/${idPaciente}`);
      const data = await res.json();
      const lista = Array.isArray(data) ? data : data.result || [];

      if (lista.length > 0) {
        const ultimo = lista[lista.length - 1];
        setCriteriosExistentes(ultimo);
        setEditId(ultimo.id);

        setRespuestas(Object.fromEntries(preguntas.map(p => [p.id, ultimo[`pregunta${p.id.slice(1)}`]])));
        setComentarios(Object.fromEntries(preguntas.map(p => [p.id, ultimo[`comentario${p.id.slice(1)}`]])));
      }
    } catch (error) {
      Swal.fire('No se han ingresado Datos');
    }
  };

  const handleChange = (id, value) => {
    setRespuestas(prev => ({ ...prev, [id]: value }));
  };

  const handleComentarioChange = (id, value) => {
    setComentarios(prev => ({ ...prev, [id]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const todasRespondidas = preguntas.every(p => respuestas[p.id]);
    if (!todasRespondidas) {
      return Swal.fire('Faltan respuestas', 'Por favor responde todas las preguntas.', 'warning');
    }

    const faltanComentarios = preguntas.some(p =>
      respuestas[p.id] === 'Sí' && !comentarios[p.id]?.trim()
    );

    if (faltanComentarios) {
      return Swal.fire('Faltan comentarios', 'Por favor completa las observaciones en respuestas "Sí".', 'warning');
    }

    const payload = {
      idPaciente,
      respuestas: preguntas.map(p => ({
        id: p.id,
        respuesta: respuestas[p.id],
      })),
      comentarios,
    };

    try {
      const url = editId
        ? `https://api.weareinfinite.mx/form/criterios_eliminacion/update/${editId}`
        : `https://api.weareinfinite.mx/form/criterios_eliminacion`;

      const method = editId ? 'PUT' : 'POST';

      const res = await fetch(url, {
        method,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      if (!res.ok) throw new Error('Error en la petición');

      Swal.fire('Éxito', 'Datos actualizados correctamente.', 'success');
      navigate(`/Cronograma/${idPaciente}`);
    } catch (error) {
      Swal.fire('Error', 'Hubo un error al guardar los datos.', 'error');
      navigate(`/Cronograma/${idPaciente}`);
    }
  };

  const bloquearFormulario = () => {
    Swal.fire({
      title: '¿Estás seguro?',
      text: 'Una vez bloqueado, necesitarás una contraseña para desbloquear.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, bloquear',
      cancelButtonText: 'Cancelar',
    }).then(result => {
      if (result.isConfirmed) {
        localStorage.setItem(BLOQUEO_KEY, 'true');
        setBloqueado(true);
        Swal.fire('Formulario bloqueado', 'Ahora está bloqueado para edición.', 'info');
      }
    });
  };

  const desbloquearFormulario = () => {
    Swal.fire({
      title: 'Desbloquear formulario',
      input: 'password',
      inputLabel: 'Introduce la contraseña',
      inputPlaceholder: 'Contraseña',
      showCancelButton: true,
      confirmButtonText: 'Desbloquear',
    }).then(result => {
      if (result.isConfirmed) {
        if (result.value === 'infinite') {
          localStorage.removeItem(BLOQUEO_KEY);
          setBloqueado(false);
          Swal.fire('Desbloqueado', 'Formulario desbloqueado.', 'success');
        } else {
          Swal.fire('Error', 'Contraseña incorrecta.', 'error');
        }
      }
    });
  };

  return (
    <div className="fondo">
      <div className="container glass">
        <img src="/image001.png" alt="Logo Infinite" className="logo" />
        <h2 style={{ color: '#ff5733' }}>Criterios de Eliminacion</h2>
        <form onSubmit={handleSubmit}>
          {preguntas.map(pregunta => {
            const respuesta = respuestas[pregunta.id];
            const esSi = respuesta === 'Sí';

            return (
              <div
                key={pregunta.id}
                className="pregunta"
                style={{
                  border: esSi ? '2px solid red' : '1px solid transparent',
                  borderRadius: '8px',
                  padding: '10px',
                  marginBottom: '15px',
                }}
              >
                <span dangerouslySetInnerHTML={{ __html: pregunta.texto }} />
                <div className="radio-group">
                  {['Sí', 'No'].map(opcion => (
                    <label className="radio-option" key={opcion}>
                      <input
                        type="radio"
                        name={pregunta.id}
                        value={opcion}
                        checked={respuesta === opcion}
                        onChange={(e) => handleChange(pregunta.id, e.target.value)}
                        disabled={bloqueado}
                      />
                      {opcion}
                    </label>
                  ))}
                </div>
                {esSi && (
                 <div className="comentario">
  <textarea
    value={comentarios[pregunta.id] || ''}
    onChange={(e) => handleComentarioChange(pregunta.id, e.target.value)}
    placeholder="Comentario sobre esta respuesta..."
    disabled={bloqueado}
    style={{ color: 'black' }} // ✅ Color del texto
  />
</div>

                )}
              </div>
            );
          })}
          <div className="form-actions">
            <button type="submit" className="submit-btn" disabled={bloqueado}>
              Guardar
            </button>
            {!bloqueado && (
              <button type="button" onClick={bloquearFormulario} className="block-btn">
                Bloquear
              </button>
            )}
            {bloqueado && (
              <button type="button" onClick={desbloquearFormulario} className="unblock-btn">
                Desbloquear
              </button>
            )}
          </div>
        </form>
      </div>
    </div>
  );
};

export default CriteriosEliminacion;
